const env = {
  domain: `${process.env.REACT_APP_AUTH_CONFIG_DOMAIN}`,
  clientId: `${process.env.REACT_APP_AUTH_CONFIG_CLIENT_ID}`,
  audience: `${process.env.REACT_APP_AUTH_CONFIG_AUDIENCE}`,
  tenantUrl: 'https://rappi-shoppers.com',
  callbackUrl: `${window.location.origin}/callback`,
  isLocal: process.env.REACT_APP_ENV === 'local',
  isDev: process.env.REACT_APP_ENV === 'staging',
  isProd: process.env.REACT_APP_ENV === 'production',
  allCountries: {
    dev: {
      label: 'Dev', timezone: 'America/Bogota', currency: 'ARS', code: 'es-AR', utc: -3, url: process.env.REACT_APP_API_BASEURL_DEV,
    },
    ar: {
      label: 'Argentina', timezone: 'America/Argentina/Buenos_Aires', currency: 'ARS', code: 'es-AR', utc: -3, url: process.env.REACT_APP_API_BASEURL_AR,
    },
    br: {
      label: 'Brazil', timezone: 'America/Paramaribo', currency: 'BRL', code: 'pt-BR', utc: -3, url: process.env.REACT_APP_API_BASEURL_BR,
    },
    cl: {
      label: 'Chile', timezone: 'America/Santiago', currency: 'CLP', code: 'es-CL', utc: -4, url: process.env.REACT_APP_API_BASEURL_CL,
    },
    co: {
      label: 'Colombia', timezone: 'America/Bogota', currency: 'COP', code: 'es-CO', utc: -5, url: process.env.REACT_APP_API_BASEURL_CO,
    },
    pe: {
      label: 'Perú', timezone: 'America/Lima', currency: 'PEN', code: 'es-PE', utc: -5, url: process.env.REACT_APP_API_BASEURL_PE,
    },
    mx: {
      label: 'México', timezone: 'America/Mexico_City', currency: 'MXN', code: 'es-MX', utc: -6, url: process.env.REACT_APP_API_BASEURL_MX,
    },
    uy: {
      label: 'Uruguay', timezone: 'America/Montevideo', currency: 'UYU', code: 'es-UY', utc: -3, url: process.env.REACT_APP_API_BASEURL_UY,
    },
    ec: {
      label: 'Ecuador', timezone: 'America/Guayaquil', currency: 'USD', code: 'es-EC', utc: -5, url: process.env.REACT_APP_API_BASEURL_EC,
    },
    cr: {
      label: 'Costa Rica', timezone: 'America/Costa_Rica', currency: 'CRC', code: 'es-CR', utc: -6, url: process.env.REACT_APP_API_BASEURL_CR,
    },
  },
  defaultCountry: process.env.REACT_APP_API_BASEURL_DEFAULT,
  shoppersApiKey: process.env.REACT_APP_SHOPPERS_API_KEY,
};

export default env;
